import React from 'react';
// @ts-ignore
import moment from 'moment';
import { useAppContext } from '../../../../Services/AppContext';
import { SelectValue } from '../../../../Components/Base/Select/Select';
import SubmitButton from '../../../../Components/Button/SubmitButton';
import apiClient from '../../../../Services/ApiClient';
import * as yup from 'yup';
import RemoveButton from '../../../../Components/Button/RemoveButton';
import useApiClient from '../../../Base/Hooks/useApiClient';
import { DocumentationFile } from '../../../../graphql/graphql';
import useTranslation from '../../../../Hooks/useTranslation';
import ECardFolderSelectField from '../../../Base/Components/Fields/ECardFolder/ECardFolderSelectField';
import InputField from '../../../../Components/Form/components/InputField';
import FormWrapper from '../../../../Components/Form/FormWrapper';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';

interface ECardEditFileValues {
	name: string;
	category: SelectValue;
}

interface Props {
	patientId: string;
	item: DocumentationFile;
	onSuccess?: (folderId: string, needReload: boolean) => void;
}

const ECardEditFile: React.FC<Props> = ({ patientId, onSuccess, item }) => {
	const { userData } = useAppContext();
	const { t } = useTranslation();
	const { displayError } = useApiClient();

	const handleSave = async (values: any) => {
		const folderId = values?.category?.value
			? values?.category?.value
			: undefined;
		const documentationUrl =
			'/patients/' + patientId + '/documentation/' + folderId + '/' + item.id;

		await apiClient.put(documentationUrl, {
			folderId: folderId,
			name: values.name,
		});

		onSuccess?.(folderId, true);
	};

	const removeFile = async () => {
		try {
			await apiClient.delete(
				`/patients/${patientId}/documentation/${item.folderId}/${item.id}`,
			);
			onSuccess?.(item.folderId, true);
		} catch (e) {
			displayError(e);
		}
	};

	const validationSchema = yup.object({
		name: yup.string().required(t('base.shared.filename')),
		category: yup.object().shape({
			value: yup.string().uuid().required(t('base.shared.category')),
		}),
	});

	const defaultValues = {
		name: item.name,
		category: item.folderId,
	};

	const formMethods = useForm({
		defaultValues: defaultValues,
		resolver: yupResolver(validationSchema),
	});

	return (
		<FormWrapper formMethods={formMethods}>
			<InputField
				name='name'
				label='base.shared.filename'
				className='mb-3'
				isRequired
			/>
			<ECardFolderSelectField
				patientId={patientId}
				name='category'
				label='base.shared.category'
				className='mb-3'
				isRequired
			/>
			<div className={'d-flex align-items-center mt-4'}>
				<SubmitButton
					title={'base.shared.save'}
					onSubmit={handleSave}
					className='btn btn-green-global remastered mr-3'
				/>
				{item?.createdBy?.id === userData?.id && (
					<RemoveButton onClick={removeFile} />
				)}
			</div>
		</FormWrapper>
	);
};

export default ECardEditFile;
